import { Box, Button, useClassNames } from '@factorialco/deprecated-design-system'
import { assignInlineVars } from '@vanilla-extract/dynamic'
import { Moment } from 'moment'

import { EmployeeForSelectFragmentNoAccess } from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import * as stylesRefs from 'modules/project_management/components/Schedule/Body/ScheduleItem/index.vanilla.css'
import { gridColumnsVar } from 'modules/project_management/components/Schedule/Body/ScheduleItem/index.vanilla.css'
import { ScheduleRecordValuesType } from 'modules/project_management/components/Schedule/Body/ScheduleItem/types'

import { getBackgroundColor } from '../utils'

interface IFooterRowProps {
  days: Moment[]
  openSidepanel: (
    data?: ScheduleRecordValuesType | null,
    employee?: EmployeeForSelectFragmentNoAccess | null
  ) => void
  employee: EmployeeForSelectFragmentNoAccess | null
}

const FooterRow = ({ days, openSidepanel, employee }: IFooterRowProps) => {
  const cx = useClassNames(stylesRefs)

  const handleOnClickAssignHoursButton = () => {
    track(trackingEvents.projectManagement.schedule.clickAssignButtonEmployee, {})
    openSidepanel(null, employee)
  }

  return (
    <Box
      className={cx('scheduleItemRow')}
      border={{ bottom: { color: 'grey300', width: 's1', style: 'solid' } }}
      height="s48"
    >
      <Box className={cx('scheduleItemFirstColumn')} justifyContent="center" paddingX="s48">
        <Button iconName="add" type="secondary" onClick={handleOnClickAssignHoursButton}>
          {i18n.t('project_management.schedule.buttons.assign')}
        </Button>
      </Box>
      <Box
        className={cx('scheduleItemDateContainer')}
        style={assignInlineVars({
          [gridColumnsVar]: days.length.toString(),
        })}
      >
        {days.map((day, index) => (
          <Box
            background={getBackgroundColor(index, days)}
            className={cx('scheduleItemCell')}
            key={index}
          >
            {''}
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default FooterRow
